import { render, staticRenderFns } from "./WelcomeCommunityComponent.vue?vue&type=template&id=88dc0d4e"
import script from "./WelcomeCommunityComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeCommunityComponent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCommunityComponent.vue?vue&type=style&index=0&id=88dc0d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports